import { render, staticRenderFns } from "./BT-AtısDep.vue?vue&type=template&id=2e9797cb&scoped=true&"
import script from "./BT-AtısDep.vue?vue&type=script&lang=js&"
export * from "./BT-AtısDep.vue?vue&type=script&lang=js&"
import style0 from "./BT-AtısDep.vue?vue&type=style&index=0&id=2e9797cb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9797cb",
  null
  
)

export default component.exports